import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaVideo,
  FaStar,
  FaEye,
  FaRocket,
  FaMobileAlt,
  FaDollarSign,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const AffordableVideoProductionServicesInDIFC = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Affordable Video Production Services in DIFC" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Quality Meets Value</Subheading>}
        heading={
          <Heading>
            Affordable{" "}
            <span tw="text-primary-500">Video Production Services</span> in DIFC
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we offer affordable video production services in
            **DIFC**, delivering high-quality videos that elevate your brand
            without breaking the bank. Get professional results at a
            budget-friendly price.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1626447852944-a375e7629e3b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1580537659466-0a9bfa916a54?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1513258496099-48168024aec0?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Start Your Video"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Affordable Video Production in DIFC"
        description="We deliver professional videos at unbeatable prices."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "High-Quality Output",
            description: "Professional visuals on a budget.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted Expertise",
            description: "Experienced team delivering value.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Engaging Content",
            description: "Videos that captivate your audience.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Delivery",
            description: "Quick turnaround without compromise.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Platform Ready",
            description: "Optimized for web and social media.",
          },
          {
            icon: <FaDollarSign color="#ff5464" size={40} />,
            title: "Cost-Effective",
            description: "Premium results at affordable rates.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Affordable Video Production Process"
        description={
          <Description>
            We create high-quality videos with a cost-efficient process:
            <ul tw="mt-4 list-disc pl-6">
              <li>Consultation: Understand your goals and budget.</li>
              <li>Planning: Develop cost-effective concepts.</li>
              <li>Filming: Capture with efficient equipment use.</li>
              <li>Editing: Polish visuals and audio affordably.</li>
              <li>Delivery: Provide ready-to-use videos.</li>
              <li>Support: Offer ongoing assistance at low cost.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1616469829581-77edf95863c9?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1540655037529-dec987208707?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1502086223501-7ea6ecd79368?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Affordable Video Wins in DIFC"
        description="Our budget-friendly videos have driven success."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Cost-Effective Campaigns",
            description: "Boosted engagement on a budget.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Brand Visibility",
            description: "Increased reach for DIFC clients.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Satisfaction",
            description: "94% approval from affordable projects.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready for Affordable Videos?</Subheading>}
        heading="Video Production in DIFC"
        description={
          <Description>
            Partner with MilaajBrandset for affordable video production services
            in DIFC. Get high-quality, impactful videos that fit your
            budget—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1574717024453-354056afd83e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1518135714426-c18f5ffb6f4d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1523741543316-beb7fc7023d8?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
